import React, { useState } from "react";
import InputTextBox from "../../../../widgets/InputTextBox";
import AppURL from "../../../../widgets/AppURL";
import { postDataToTheServer } from "../../../../widgets/api";
import DefaultImage from '../../../../assets/img/img/default-img.png'
import { IoIosCheckmarkCircle } from "react-icons/io";

const SingleStudentFeeReportsListView = () => {
  const [studentId, setStudentId] = useState("");
  const [feeData, setFeeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [onDetails, setOnDetails] = useState({});
  // ✅ Handle Enter Key Press
  const handleKeyDown = async (e) => {
    if (e.key === "Enter" && studentId.trim() !== "") {
      await fetchStudentData(studentId);
    }
  };

  // ✅ Fetch data from API
  const fetchStudentData = async (id) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("member_sn", id);

      const res = await postDataToTheServer(
        AppURL.AccountsURL + `account-single-student-fee-report-list-view/`,
        formData
      );
      setLoading(false);
      setOnDetails(res.details);
      if (res && res.results) {
        setFeeData(res.results);
      } else {
        setFeeData([]);
      }
    } catch (error) {
      setLoading(false);
      console.error("Fetch error:", error);
    }
  };

  // ✅ FeeList Component
  const FeeList = ({ data }) => {
    const groupedData = data.reduce((acc, item) => {
      const programKey = item.programtitle;
      const yearKey = item.yearsemestername;

      if (!acc[programKey]) acc[programKey] = {};
      if (!acc[programKey][yearKey]) acc[programKey][yearKey] = [];

      acc[programKey][yearKey].push(item);
      return acc;
    }, {});

    const calculateTotal = (fees) =>
      fees.reduce((sum, fee) => sum + (fee.creditamt || 0), 0);

    return (
      <div className="space-y-6 font-public-sans">
        {Object.entries(groupedData).map(([program, years]) => (
          <div
            key={program}
            className="bg-white rounded-md border border-gray-200 overflow-hidden"
          >
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-2">
              <h2 className="text-lg font-bold text-white">{program}</h2>
            </div>

            <div className="p-6 space-y-6">
              {Object.entries(years).map(([year, fees]) => (
                <div
                  key={year}
                  className="border border-gray-200 rounded-lg overflow-hidden"
                >
                  <div className="bg-white px-4 py-2 flex gap-1 border-b border-gray-200">
                   <IoIosCheckmarkCircle size={20} className="my-auto text-blue-600" /> <h3 className="text-md font-bold text-blue-600">
                      {year}
                    </h3>
                  </div>

                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="bg-gray-300 ">
                            <th className="px-4 w-10 py-1 text-left text-[12px] font-bold text-gray-900 border border-gray-200">
                            S.N.
                          </th>
                          <th className="px-4 py-1 text-left text-[12px] font-bold text-gray-900 border border-gray-200">
                            Fee Type
                          </th>
                          <th className="px-4 py-1 text-right text-[12px] font-bold text-gray-900 border border-gray-200">
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200">
                        {fees.map((fee, index) => (
                          <tr
                            key={index}
                            className="hover:bg-blue-50 transition-colors"
                          >
                             <td className="px-4 py-1 text-[12px] text-gray-700 border border-gray-200">
                              {index+1}.
                            </td>
                            <td className="px-4 py-1 text-[12px] text-gray-700 border border-gray-200">
                              {fee.particular_name}
                            </td>
                            <td className="px-4 py-1 text-[12px] text-gray-900 text-right font-medium border border-gray-200">
                              Rs {fee.creditamt.toLocaleString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot className="bg-blue-600">
                        <tr>
                          <td colSpan={2} align="end" className="px-4 py-1 text-[12px] font-semibold text-white border-r border-blue-500">
                            Total for {year}
                          </td>
                          <td className="px-4 py-1 text-[12px] font-semibold text-white text-right">
                            Rs {calculateTotal(fees).toLocaleString()}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 font-public-sans p-6">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        {/* Sidebar */}
        <div className="lg:col-span-1">
          <div className="bg-white rounded-md border border-gray-200 overflow-hidden sticky top-8">
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-8 text-center">
              <div className=" mx-auto mb-4 flex items-center justify-center">
                <img src={onDetails?.photo? AppURL.BaseURL + onDetails?.photo : DefaultImage} alt="" className="w-20 h-20 bg-white rounded-full" />
              </div>

              <h2 className="text-md font-bold text-white mb-1">
                Search Student
              </h2>

              <p className="text-blue-100">
                Student ID:
                <InputTextBox
                  value={studentId}
                  handleChange={(e) => setStudentId(e.target.value)}
                  onKeyPress={handleKeyDown}
                  placeholder="Enter ID & press Enter"
                />
              </p>
            </div>
          </div>
        </div>

        {/* Fee Section */}
        <div className="lg:col-span-3">
          {loading ? (
            <div className="text-center py-12 text-blue-600 font-medium">
              Loading data...
            </div>
          ) : feeData.length > 0 ? (
            <FeeList data={feeData} />
          ) : (
            <div className="text-center py-12 text-gray-500">
              Enter Student ID and press Enter to view fee report.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleStudentFeeReportsListView;
